import baseAPI from '@/http'

const router = 'api/usuario/permissao'

export const permissionAPI = {
  create: (permission) => baseAPI.post(router, permission),
  update: (permission) => baseAPI.put(router, permission),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`)
}
